import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    getDijikolayCustomers,
    updateDijikolayStatus,
    updateDijikolayContacted,
    updateDijikolayResponsible
} from '../../services/dijikolay';
import {
    fetchDijikolayCustomersRequest,
    fetchDijikolayCustomersSuccess,
    fetchDijikolayCustomersFailure,
    updateDijikolayStatusRequest,
    updateDijikolayContactedRequest,
    updateDijikolayResponsibleRequest,
    updateDijikolaySuccess,
    updateDijikolayFailure,
} from '../reducers/dijikolay/dijikolaySlice';
import { RootState } from '../store';
import { PayloadAction } from '@reduxjs/toolkit';
import {
    DijikolayCustomer,
    UpdateStatusPayload,
    UpdateContactedPayload,
    UpdateResponsiblePayload
} from '../reducers/dijikolay/dijikolay.types';

type DijikolayCustomerResponse = { data: { customers: DijikolayCustomer[] } };
type SingleDijikolayCustomerResponse = { data: { dijikolay: DijikolayCustomer } };


function* fetchDijikolayCustomersSaga() {
    try {
        const response: DijikolayCustomerResponse = yield call(getDijikolayCustomers);
        yield put(fetchDijikolayCustomersSuccess(response.data.customers));
    } catch (error: any) {
        yield put(fetchDijikolayCustomersFailure(error.message || 'An error occurred'));
    }
}

function* updateStatusSaga(action: PayloadAction<UpdateStatusPayload>) {
    try {
        const { id, status } = action.payload;
        const response: SingleDijikolayCustomerResponse = yield call(updateDijikolayStatus, id, status);
        yield put(updateDijikolaySuccess(response.data.dijikolay));
    } catch (error: any) {
        yield put(updateDijikolayFailure(error.message || 'Failed to update status'));
    }
}

function* updateContactedSaga(action: PayloadAction<UpdateContactedPayload>) {
    try {
        const { id } = action.payload;
        const response: SingleDijikolayCustomerResponse = yield call(updateDijikolayContacted, id);
        yield put(updateDijikolaySuccess(response.data.dijikolay));
    } catch (error: any) {
        yield put(updateDijikolayFailure(error.message || 'Failed to update contacted status'));
    }
}

function* updateResponsibleSaga(action: PayloadAction<UpdateResponsiblePayload>) {
    try {
        const { id, responsible } = action.payload;
        const response: SingleDijikolayCustomerResponse = yield call(updateDijikolayResponsible, id, responsible);
        yield put(updateDijikolaySuccess(response.data.dijikolay));
    } catch (error: any) {
        yield put(updateDijikolayFailure(error.message || 'Failed to update responsible'));
    }
}


export function* watchDijikolaySaga() {
    yield all([
        takeLatest(fetchDijikolayCustomersRequest.type, fetchDijikolayCustomersSaga),
        takeLatest(updateDijikolayStatusRequest.type, updateStatusSaga),
        takeLatest(updateDijikolayContactedRequest.type, updateContactedSaga),
        takeLatest(updateDijikolayResponsibleRequest.type, updateResponsibleSaga),
    ]);
}